import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  FinanceManager,
  FinanceManagerResponse,
  Withdrawal,
  WithdrawalRequest,
  WithdrawalResponse,
} from './types'
import { transactionRequestDirection } from '../../const'
import type { FastFilter } from './types'

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

const DATE_FIELDS = ['updatedAt', 'createdAt']

const mapSearchEntry = (key: string, value: any): [string, any] => {
  if (key === 'transactionId') {
    return ['id', value?.toLowerCase()]
  }

  if (key === 'client') {
    return ['client.email', value?.toLowerCase()]
  }

  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => (date ? changedDateFormat(date?.$d) : `${date}`))
      : value
    return [key, dates]
  }

  return [key, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) =>
      mapSearchEntry(key, value),
    ),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const withdrawalsListMounted = createEvent<WithdrawalRequest>()

export const financeManagerMounted = createEvent()

export const getWithdrawals = fx<WithdrawalRequest, WithdrawalResponse>({
  method: 'GET',
  url: `/transaction_request`,
})

export const getFinanceManager = fx<any, FinanceManagerResponse>({
  method: 'GET',
  url: `/user/by_role/finance_manager`,
})

export const $withdrawals = restore<Withdrawal[]>(
  getWithdrawals.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfWithdrawals = restore(
  getWithdrawals.doneData.map((a) => a.body.total),
  0,
)

export const $financeManagers = restore<FinanceManager[]>(
  getFinanceManager.doneData.map((a) => a.body.items),
  [],
)

// Быстрые фильтры

export const getFastFilters = fx<void, FastFilter[]>({
  method: 'GET',
  url: '/transaction_request/withdrawal/fast_filters',
})

export const $resetFastFilters = createEvent()

export const $fastFilters = restore<FastFilter[]>(
  getFastFilters.doneData.map((a) => a.body),
  [],
).reset($resetFastFilters)

sample({
  // @ts-ignore
  clock: withdrawalsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status' ||
            key === 'product' ||
            key === 'initialCurrency' ||
            key === 'clientCurrency' ||
            key === 'changeHistory.user.email'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      newObj['direction'] = transactionRequestDirection.Out()

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getWithdrawals,
})

sample({
  // @ts-ignore
  clock: financeManagerMounted,
  fn: () => {
    return {
      url: '/user/by_role/finance_manager',
    }
  },
  target: getFinanceManager,
})
